import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-order-list.actions';
import { GetOrderListState } from './get-order-list.state';

/**
 * getOrderList initial state
 */
export const getOrderListInitialState: GetOrderListState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetOrderList Store
 */
export const getOrderListReducerFeatures: ReducerTypes<GetOrderListState, ActionCreator[]>[] = [
  on(actions.setGetOrderList, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetOrderList, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetOrderList, () => getOrderListInitialState),

  on(actions.cancelGetOrderListRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetOrderList, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setGetOrderListFromApi, actions.updateGetOrderListFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetOrderList Store reducer
 */
export const getOrderListReducer = createReducer(getOrderListInitialState, ...getOrderListReducerFeatures);
